import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 sm:py-10 px-4 bg-brand-cream" data-id="element-93" data-mp="1o3x3nprb6w3l">
      <div className="max-w-3xl mx-auto" data-id="element-94" data-mp="1o3doggt1mlt9">
        <div className="bg-white border-4 border-brand-petrol/30 p-5 sm:p-6 rounded-xl text-center" data-id="element-95" data-mp="223y5p8jb89kn">
          <p className="text-sm font-bold text-brand-petrol uppercase tracking-wide mb-2" data-id="element-96" data-mp="1x3tofgakvatd">
            YOUR INVESTMENT IS 100% PROTECTED
          </p>
          <div className="w-16 h-16 mx-auto bg-brand-petrol/10 rounded-full flex items-center justify-center mb-3" data-id="element-97" data-mp="19f0m923d46qb">
            <ShieldCheck className="w-8 h-8 text-brand-petrol" data-id="element-98" data-mp="14dte31xb55j4" />
          </div>
          <h3 className="text-xl sm:text-2xl font-serif font-bold text-brand-graphite mb-2" data-id="element-99" data-mp="1j5vc0gfthogi">
            7-Day Total Guarantee
          </h3>
          <p className="text-base font-bold text-brand-petrol mb-3" data-id="element-100" data-mp="qnzryrd6szd3">
            Your money is 100% protected
          </p>
          <div className="text-base text-brand-graphite/80 space-y-3 max-w-2xl mx-auto leading-relaxed" data-id="element-101" data-mp="lo50ompi27ri">
            <p data-id="element-102" data-mp="oygjg8qup27n">
              You have 7 full days to explore the 6 modules, apply the workouts
              and templates with your clients, and experience the difference in
              your sessions. If you are not fully satisfied for any reason, we
              will refund 100% of your money. Zero risk for you, total
              commitment from us.
            </p>
          </div>
        </div>
      </div>
    </section>;
}